import React, { useContext } from 'react'

export type TFieldContextValue = {
  prefix: string | undefined
}

const FieldContext = React.createContext<TFieldContextValue>({
  prefix: undefined,
})

export default FieldContext

export const useFieldPrefix = (): TFieldContextValue => useContext(FieldContext)
